import { paths, routes } from 'config/paths';
import * as React from 'react';

import {
	SideNav,
	SideNavProps,
} from '~ui-components/components/molecules/side-nav';

export const layersNavItemKeys = {
	standard: 'standard',
	radio: 'radio',
	disabled: 'disabled',
};

const navItems: SideNavProps['navItems'] = [
	{
		items: [
			{
				title: 'Standard',
				href: paths.accountName.maps.mapId.mapName.layers.root(
					'john-doe',
					'cambodia-map',
					'cambodia'
				),
				matcher: {
					type: 'equals',
					href: routes.accountName.maps.mapId.mapName.layers.root,
				},
			},
			{
				title: 'Radio',
				href: paths.accountName.maps.mapId.mapName.layers.radio(
					'john-doe',
					'cambodia-map',
					'cambodia'
				),
				matcher: {
					type: 'equals',
					href: routes.accountName.maps.mapId.mapName.layers.radio,
				},
			},
			{
				title: 'Disabled',
				href: paths.accountName.maps.mapId.mapName.layers.disabled(
					'john-doe',
					'cambodia-map',
					'cambodia'
				),
				matcher: {
					type: 'equals',
					href: routes.accountName.maps.mapId.mapName.layers.disabled,
				},
			},
		],
	},
];

export function LayersSideNav(): React.JSX.Element {
	return <SideNav navItems={navItems} />;
}
